import React from 'react';

const Desaprobados = () => {
  return (
    <div>
      Hola, soy eventos desaprobados
    </div>
  );
};

export default Desaprobados;